<template>
    <v-app id="inspire">
 
      <v-app-bar
      class="mt-4"
      max-height="50"
      color="deep-purple"
      dark
    >
      <v-app-bar-nav-icon @click="drawer = true"></v-app-bar-nav-icon>

      <v-toolbar-title>Django+Vuetifyで作った掲示板</v-toolbar-title>
    </v-app-bar>

    <v-navigation-drawer
      v-model="drawer"
      absolute
      temporary
    >
      <v-list
        nav
        dense
      >
        <!-- <v-list-item-group
          v-model="group"
          active-class="deep-purple--text text--accent-4"
        > -->
        <v-list-item-group

          active-class="deep-purple--text text--accent-4"
        >
        <v-list-item href="https://kikuichige.com" target="_blank">
             <v-list-item-icon>
                 <v-icon>mdi-home</v-icon>
                </v-list-item-icon>
                <v-list-item-title>イチゲブログ</v-list-item-title>
         </v-list-item>

         <v-list-item href="https://vuetifyjs.com/ja/" target="_blank">
             <v-list-item-icon>
                 <v-icon>mdi-home</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Vuetify</v-list-item-title>
         </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

      <v-main class="grey lighten-2">
        <v-container>
        <v-row>
            <v-col class="mt-2" cols="12">
              <v-sheet height="230" color="orange lighten-2" class="mt-2 mx-auto" max-width="400">
                    <v-text-field
                    v-model="new_article_heading"
                    label="名前を入力してください"
                    filled>
                  </v-text-field>
                    <v-text-field
                    v-model="new_article_body"
                    label="メッセージを入力してください"
                    filled>
                  </v-text-field>
                  <v-btn color="success" dark v-on:click="createNewUser">投稿</v-btn>
              </v-sheet>
            </v-col>
            <template v-for="(article, index) in reverseItems">
            <v-col
              :key="index"
              class="mt-2"
              cols="12"
            >
            <!-- <v-col cols="4"> -->
                <v-card
                    class="mt-2 mx-auto"
                    max-width="400"
                    color="lime lighten-5"
                >
                    <!-- <v-card-subtitle class="pb-0 text-h6">Vutifyでポートフォリオつくりました！
                    </v-card-subtitle> -->

                    <v-card-text class="text--primary">
                    <div><br>ID: {{ article.article_id}}<br>名前: {{ article.article_heading}}<br>{{ article.article_body}}</div>
                    <!-- <a href="https://menta.work/user/46880" target="_blank">MENTAやってます（ichige</a>） -->
                    </v-card-text>
                    <v-card-text>
                      <div>{{ article.pub_date|printDate }}</div>
                    </v-card-text>
                    <v-card-actions>
                        <!-- <v-btn href="https://kikuichige.com/category/programing/" text color="black" outlined rounded target="_blank">関連記事</v-btn> -->
                        <v-btn color="success" dark v-on:click="DeletedArc(article.article_id)">削除</v-btn>
                    </v-card-actions>
                </v-card>
            <!-- </v-col> -->
            </v-col></template>

        </v-row>
        </v-container>
      </v-main>
      <!-- フッター -->
      <v-footer padless>
          <v-col
            class="text-center"
            cols="12"
          >
            <p>Copyright (c) 2023 イチゲブログ</p><v-btn href="https://opensource.org/licenses/mit-license.php">Released under the MIT license</v-btn>
          </v-col>
      </v-footer>
      <!-- フッターend -->
    </v-app>
  </template>
  
  <script>
  import axios from 'axios';
  import moment from 'moment';
    export default {
        data() { 
            return{
                drawer: null,
                articles: [],
                new_article_heading:'',
                new_article_body:'',
                del_article_id:'',
            };
        },  
        methods: {
            getArticles() {
                // axios.get('http://127.0.0.1:8000/api/article/',{
                  axios.get('/api/article/',{
                // withCredentials: true
                })
                .then(response => {
                    this.articles=response.data;
                    console.log(this.articles);
                })
                    .catch((err) => {
                    this.loading = false;
                    console.log(err);
                })
            },
            createNewUser: function(){
              var date = new Date();
              console.log('投稿に来た');
            //  axios.post('http://127.0.0.1:8000/api/article/',{
              axios.post('/api/article/',{
                 "article_heading": this.new_article_heading,
                 "article_body": this.new_article_body,
                 "pub_date":date,
         
                 },{
                      // withCredentials: true
                    })
                  .then(location.reload())
                  .catch(error => console.log(error))     
            },
            DeletedArc: function(delId){
              console.log(delId);
              var delurl="/api/article/"+delId+"/";
             axios.delete(delurl,{
                      // withCredentials: true
                    })
                  .then(location.reload())
                  .catch(error => console.log(error))     
            },
        },
        mounted () {
            axios.defaults.xsrfCookieName = 'csrftoken' ;// ←ココと
            axios.defaults.xsrfHeaderName = "X-CSRFTOKEN"; // ←ココに追加しました
            
            this.getArticles();
        },
        computed: {
            reverseItems() {
        return this.articles.slice().reverse();
        },
        },
        filters: {
          printDate (val) {
            return moment(val).locale('ja').format('YYYY年MM月DD日(ddd) HH時mm分ss秒')
          },
        },
    }
  </script>